import React, { useState, useEffect } from 'react';
import { tiendasApi } from '../services/api';
import { useSucursal } from '../context/SucursalContext';

const Sucursales = () => {
  const { refreshSucursales } = useSucursal();
  const [sucursales, setSucursales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingSucursal, setEditingSucursal] = useState(null);
  const [filtroActiva, setFiltroActiva] = useState('todas');
  const [formData, setFormData] = useState({
    nombre: '',
    direccion: '',
    telefono: '',
    activa: true
  });

  useEffect(() => {
    loadSucursales();
  }, []);

  const loadSucursales = async () => {
    setLoading(true);
    try {
      const response = await tiendasApi.getAll();
      setSucursales(response.data || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredSucursales = sucursales.filter(s => {
    if (filtroActiva === 'todas') return true;
    if (filtroActiva === 'activas') return s.activa;
    if (filtroActiva === 'inactivas') return !s.activa;
    return true;
  });

  const handleOpenModal = (sucursal = null) => {
    if (sucursal) {
      setEditingSucursal(sucursal);
      setFormData({
        nombre: sucursal.nombre,
        direccion: sucursal.direccion || '',
        telefono: sucursal.telefono || '',
        activa: sucursal.activa === 1 || sucursal.activa === true
      });
    } else {
      setEditingSucursal(null);
      setFormData({ nombre: '', direccion: '', telefono: '', activa: true });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingSucursal(null);
    setFormData({ nombre: '', direccion: '', telefono: '', activa: true });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingSucursal) {
        await tiendasApi.update(editingSucursal.id, formData);
      } else {
        await tiendasApi.create(formData);
      }
      loadSucursales();
      refreshSucursales();
      handleCloseModal();
    } catch (error) {
      alert('Error al guardar la sucursal');
    }
  };

  const handleToggleActive = async (sucursal) => {
    try {
      await tiendasApi.update(sucursal.id, {
        ...sucursal,
        activa: !sucursal.activa
      });
      loadSucursales();
      refreshSucursales();
    } catch (error) {
      alert('Error al actualizar la sucursal');
    }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Sucursales</h1>
          <p className="page-subtitle">{sucursales.filter(s => s.activa).length} sucursales activas</p>
        </div>
        <button onClick={() => handleOpenModal()} className="btn btn-primary">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Nueva Sucursal
        </button>
      </div>

      {/* Filtros */}
      <div className="filters-bar">
        <div className="form-group" style={{ marginBottom: 0, minWidth: '150px' }}>
          <select
            className="form-control"
            value={filtroActiva}
            onChange={(e) => setFiltroActiva(e.target.value)}
          >
            <option value="todas">Todas</option>
            <option value="activas">Activas</option>
            <option value="inactivas">Inactivas</option>
          </select>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : filteredSucursales.length === 0 ? (
          <div className="empty-state">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <path d="M9 22V12h6v10"/>
            </svg>
            <h3>No hay sucursales</h3>
            <p>Registra tu primera sucursal</p>
          </div>
        ) : (
          <div className="stats-grid">
            {filteredSucursales.map(sucursal => (
              <div
                key={sucursal.id}
                className="sucursal-card"
                style={{ opacity: sucursal.activa ? 1 : 0.6 }}
              >
                <div className="sucursal-card-header">
                  <h4 className="sucursal-card-title">{sucursal.nombre}</h4>
                  <span className={`status-badge ${sucursal.activa ? 'status-terminada' : 'status-pendiente'}`}>
                    {sucursal.activa ? 'Activa' : 'Inactiva'}
                  </span>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  {sucursal.direccion && (
                    <p style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '8px', fontSize: '14px', color: 'var(--text-light)' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16" style={{ flexShrink: 0, marginTop: '2px' }}>
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                      {sucursal.direccion}
                    </p>
                  )}
                  {sucursal.telefono && (
                    <p style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: 'var(--text-light)' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                      </svg>
                      {sucursal.telefono}
                    </p>
                  )}
                </div>

                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    onClick={() => handleOpenModal(sucursal)}
                    className="btn btn-secondary btn-sm"
                    style={{ flex: 1 }}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                    Editar
                  </button>
                  <button
                    onClick={() => handleToggleActive(sucursal)}
                    className={`btn btn-sm ${sucursal.activa ? 'btn-danger' : 'btn-success'}`}
                  >
                    {sucursal.activa ? 'Desactivar' : 'Activar'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">
                {editingSucursal ? 'Editar Sucursal' : 'Nueva Sucursal'}
              </h2>
              <button className="modal-close" onClick={handleCloseModal}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Nombre de la Sucursal *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.nombre}
                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                    placeholder="Ej: Intersecom Zona 1"
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Dirección</label>
                  <textarea
                    className="form-control"
                    value={formData.direccion}
                    onChange={(e) => setFormData({ ...formData, direccion: e.target.value })}
                    placeholder="Dirección completa de la sucursal"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Teléfono(s)</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.telefono}
                    onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                    placeholder="Ej: 7760 3991 / 7725 4830"
                  />
                </div>
                <div className="form-group">
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={formData.activa}
                      onChange={(e) => setFormData({ ...formData, activa: e.target.checked })}
                    />
                    Sucursal Activa
                  </label>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sucursales;
